import React, { useState, useEffect } from "react";
import GeneralLayout from "components/PageLayouts/GeneralLayout";
import GenericRecordSelection from "components/Records/RecordSelection/GenericRecordSelection";
import AddCampaignPopup from "./Campaigns/AddCampaignPopup";
import CampaignDetail from "./Campaigns/CampaignDetail";
import CampaignBottomDrawer from "./Campaigns/CampaignBottomDrawer";
import { campaignAPI } from "api/Campaigns/CampaignAPI";
import { Campaign } from "api/Campaigns/CampaignInterfaces";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

const Campaigns: React.FC = () => {
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(null);
  const [selectedNode, setSelectedNode] = useState<any | null>(null);
  const [savingNode, setSavingNode] = useState(false);

  const { id: routeId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleNodeUpdate = (node: any) => {
    setSavingNode(true);
    setSelectedNode(node);
    setSavingNode(false);
  };

  const handleSelectCampaign = (id: number) => {
    navigate(`/campaigns/${id}/`);
  };

  const handleCampaignCreated = (newCampaign: Campaign) => {
    setSelectedCampaign(newCampaign);
  };

  /** Safe selected ID from URL */
  const activeId =
    routeId ? Number(routeId) :
    searchParams.get("id") ? Number(searchParams.get("id")) :
    null;

  /* -------------------- Load selected campaign when URL changes -------------------- */
  useEffect(() => {
    if (!activeId) {
      setSelectedCampaign(null);
      return;
    }

    campaignAPI
      .getById(activeId)
      .then((detail) => setSelectedCampaign(detail))
      .catch(() => setSelectedCampaign(null));
  }, [activeId]);

  return (
    <GeneralLayout
      useLeftDrawer
      defaultOpenLeft={true}
      useBottomDrawer
      leftDrawerContent={
        <GenericRecordSelection<Campaign>
          fetchItems={campaignAPI.getAll}
          onSelect={(c) => handleSelectCampaign(c.id)}
          selectedId={activeId ?? null}
          AddPopupComponent={AddCampaignPopup}
          onCreated={handleCampaignCreated}
          colorKey="campaignsPrimary"
          idKey="id"
          nameKey={(c) => c.name || `Campaign ${c.id}`}
          searchPlaceholder="Search campaigns..."
        />
      }
      bottomDrawerContent={
        activeId ? (
          <CampaignBottomDrawer
            selectedNode={selectedNode}
            onUpdateNode={handleNodeUpdate}
            savingNode={savingNode}
          />
        ) : null
      }
    >
      <CampaignDetail
        campaign={selectedCampaign}
        selectedNode={selectedNode}
        onNodeSelect={setSelectedNode}
        onUpdateNode={handleNodeUpdate}
        savingNode={savingNode}
        onCampaignCreated={handleCampaignCreated}
      />
    </GeneralLayout>
  );
};

export default Campaigns;
